import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "search", "row", "line", "group", "panel",
    "viewButton", "statusButton", "empty", "count"
  ]

  connect() {
    this.view = "competency"
    this.status = "all"
  }

  setView(event) {
    this.view = event.currentTarget.dataset.view
    this.viewButtonTargets.forEach((button) => {
      const active = button.dataset.view === this.view
      button.classList.toggle("is-active", active)
      button.setAttribute("aria-pressed", active ? "true" : "false")
    })
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.view !== this.view
    })
    this.apply()
  }

  setStatus(event) {
    this.status = event.currentTarget.dataset.status
    this.statusButtonTargets.forEach((button) => {
      const active = button.dataset.status === this.status
      button.classList.toggle("is-active", active)
      button.setAttribute("aria-pressed", active ? "true" : "false")
    })
    this.apply()
  }

  filter() {
    this.apply()
  }

  apply() {
    const query = this.searchTarget.value.trim().toLowerCase()
    const panel = this.panelTargets.find((item) => item.dataset.view === this.view)

    this.rowTargets.forEach((row) => {
      if (!panel.contains(row)) return

      const text = (row.dataset.search || "").toLowerCase()
      const statuses = (row.dataset.status || "").split(/\s+/)
      const matchesQuery = query === "" || text.includes(query)
      const matchesStatus = this.status === "all" || statuses.includes(this.status)
      row.hidden = !(matchesQuery && matchesStatus)
    })

    this.lineTargets.forEach((line) => {
      const row = line.closest("[data-sim-signoff-table-target='row']")
      if (!row || !panel.contains(line)) return
      if (row.hidden) {
        line.hidden = true
        return
      }

      const lineText = (line.dataset.search || "").toLowerCase()
      const lines = row.querySelectorAll("[data-sim-signoff-table-target='line']")
      const queryNamesALearner = query !== "" && Array.from(lines).some((item) => {
        return (item.dataset.search || "").toLowerCase().includes(query)
      })
      const matchesQuery = query === "" || !queryNamesALearner || lineText.includes(query)
      const matchesStatus = this.status === "all" || line.dataset.status === this.status
      line.hidden = !(matchesQuery && matchesStatus)
    })

    this.rowTargets.forEach((row) => {
      if (!panel.contains(row) || row.hidden) return
      const lines = row.querySelectorAll("[data-sim-signoff-table-target='line']")
      if (lines.length === 0) return
      if (Array.from(lines).every((line) => line.hidden)) row.hidden = true
    })

    this.groupTargets.forEach((group) => {
      if (!panel.contains(group)) return
      const rows = Array.from(group.querySelectorAll("[data-sim-signoff-table-target='row']"))
      const shown = rows.filter((row) => !row.hidden).length
      group.hidden = shown === 0
      const count = group.querySelector("[data-sim-signoff-table-target='count']")
      if (!count) return
      const total = count.dataset.total
      count.textContent = shown === Number(total) ? `${total} still open` : `${shown} of ${total}`
    })

    const visible = panel.querySelectorAll("[data-sim-signoff-table-target='row']:not([hidden])")
    this.emptyTarget.hidden = visible.length > 0
  }
}
